import Splide from '@splidejs/splide';

export function splide() {
	const topKeywordsSlides = document.querySelectorAll('.js-top-keywords-slide');

	topKeywordsSlides.forEach((item) => {
		const options = {
			type: 'loop',
			// rewind: true,
			speed: 1000,
			// autoplay: true,
			// interval: 4000,
			pauseOnHover: false,
			// fixedWidth: 418,
			autoWidth: true,
			gap: 0,
			arrows: true,
			pagination: false,
		};

		const slide = new Splide(item, options);
		slide.mount();
	});

	const topInternshipSlides = document.querySelectorAll('.js-top-internship-slide');

	topInternshipSlides.forEach((item) => {
		const options = {
			// type: 'loop',
			// rewind: true,
			speed: 1000,
			// autoplay: true,
			// interval: 4000,
			pauseOnHover: false,
			// fixedWidth: 418,
			autoWidth: true,
			gap: 0,
			arrows: true,
			pagination: false,
			breakpoints: {
	      768: {
		      gap: 15,
	      }
	    },
		};

		const slide = new Splide(item, options);
		slide.mount();
	});

	const topPickSlides = document.querySelectorAll('.js-top-pick-slide');

	topPickSlides.forEach((item) => {
		const options = {
			type: 'loop',
			// rewind: true,
			speed: 1000,
			// autoplay: true,
			// interval: 4000,
			pauseOnHover: false,
			// fixedWidth: 900,
			autoWidth: true,
			gap: 0,
			arrows: true,
			pagination: false,
			breakpoints: {
				768: {
					type: 'slide',
					gap: 15,
				}
			},
		};

		const slide = new Splide(item, options);
		slide.mount();
	});

	// const fadeSlides = document.querySelectorAll('.js-fade-slide');
	//
	// fadeSlides.forEach((slide) => {
	// 	const fadeOptions = {
	// 		rewind: true,
	// 		speed: 3000,
	// 		autoplay: true,
	// 		interval: 4000,
	// 		pauseOnHover: false,
	// 		type: 'fade',
	// 		arrows: false,
	// 		pagination: false,
	// 	};
	//
	// 	const fadeSplide = new Splide(slide, fadeOptions);
	// 	fadeSplide.mount();
	// });


  // if (document.getElementsByClassName('-top').length) {
  //   const mvOptions = {
  //     rewind: true,
  //     speed: 3000,
  //     autoplay: true,
  //     interval: 4000,
  //     pauseOnHover: false,
  //     type: 'fade',
  //     arrows: false,
  //     pagination: false,
  //   }
  //   const mvLeftSplide = new Splide( '.js-mv-slide.-left', mvOptions );
  //   const mvRightSplide = new Splide( '.js-mv-slide.-right', mvOptions );
	//
  //   mvLeftSplide.mount();
  //   window.setTimeout(() => {
  //     mvRightSplide.mount();
  //   }, 50);
	//
  //   const aboutOptions = {
  //     rewind: true,
  //     speed: 2000,
  //     autoplay: true,
  //     interval: 4000,
  //     type: 'loop',
  //     updateOnMove: true,
  //     gap: 60,
  //     arrows: false,
  //     classes: {
  //       pagination: 'top-slide__pagination',
  //       // page: 'top-slide__btn'
  //     },
  //   }
  //   const aboutSplide = new Splide( '.js-about-slide', aboutOptions );
	//
  //   aboutSplide.mount();
	//
  //   const planOptions = {
  //     rewind: true,
  //     speed: 2000,
  //     // autoplay: true,
  //     interval: 4000,
  //     // type: 'loop',
  //     updateOnMove: true,
  //     gap: '6.4vw',
  //     width: '84vw',
  //     arrows: false,
  //     destroy: true,
  //     classes: {
  //       pagination: 'top-plan__pagination',
  //       // page: 'top-slide__btn'
  //     },
  //     breakpoints: {
  //       768: {
  //         destroy: false,
  //       }
  //     },
  //   }
  //   const planSplide = new Splide( '.js-plan-slide', planOptions );
	//
  //   planSplide.mount();
  // }
	//

  // if (document.getElementsByClassName('js-basic-slide').length) {
  //   const basicOptions = {
  //     // rewind: true,
	// 		mediaQuery: 'min',
  //     speed: 800,
  //     // autoplay: true,
  //     // interval: 4000,
  //     // type: 'loop',
  //     updateOnMove: true,
  //     // width: '895px',
  //     gap: 30,
  //     arrows: true,
	// 		pagination: false,
  //     // arrowPath: 'M13.9,19.9v.2l13.4,15.16-1.12,4.58L8.87,20.1v-.2L26.18,.17l1.12,4.58-13.4,15.16Z',
  //     classes: {
  //       arrows: 'splide__arrows top-example__arrows',
  //       arrow : 'splide__arrow top-example__arrow',
  //       // pagination: 'educational-flow__pagination',
  //       // page: 'top-slide__btn'
  //     },
  //     breakpoints: {
  //       // 1160: {
  //       //   width: '78%',
  //       // },
	// 			576: {
  //         fixedWidth: '48%',
	// 				gap: '4%',
	// 				perMove: 2,
  //         // gap: '5.3333333333vw'
  //       },
  //       768: {
  //         fixedWidth: '31%',
	// 				gap: '3%',
	// 				perMove: 3,
  //         // gap: '5.3333333333vw'
  //       },
	// 			1130: {
	// 				fixedWidth: '346px',
	// 				gap: 28,
	// 			}
  //     },
  //   }
  //   const flowSplide = new Splide( '.js-basic-slide', basicOptions );
	//
  //   flowSplide.mount();
  // }

  // if (document.getElementsByClassName('js-gallery-slide').length) {
  //   const mainOptions = {
  //     type: 'fade',
  //     arrows: false,
  //     pagination: false,
  //   }
  //   const mainSplide = new Splide('.js-gallery-slide', mainOptions);
	//
  //   const thumbs = document.querySelectorAll('.js-gallery-thumb');
  //   let current; // 現在のサムネイルを保持するための変数
	//
  //   const initThumb = (thumb, index) => {
  //     thumb.addEventListener('click', () => {
  //       mainSplide.go(index);
  //     });
  //   }
	//
  //   for (let i = 0; i < thumbs.length; i++) {
  //     initThumb(thumbs[i], i);
  //   }
	//
  //   mainSplide.on('mounted move', () => {
  //     if (current) {
  //       current.classList.remove('is-active');
  //     }
	//
  //     // Splide#indexは現在アクティブなスライドのインデックスを返す
  //     const thumb = thumbs[mainSplide.index];
  //     if (thumb) {
  //       thumb.classList.add('is-active');
  //       current = thumb;
  //     }
  //   });
	//
  //   mainSplide.mount();
  // }
}
